import { render } from "./mainCard.vue?vue&type=template&id=2a399b92&scoped=true&lang=pug"
const script = {}

import "./mainCard.vue?vue&type=style&index=0&id=2a399b92&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a399b92"]])

export default __exports__